import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { api, getEventById, getEventInfosByEventId, getTicketTypesByEventId, getTicketTypeInfosByTicketTypeId, getTicketTypeNumberOfAvailableTickets } from "ticketino-api-client";
import { Helmet } from "react-helmet-async";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Loading from "./components/Loading";
import InformationAndTariff from "./components/InformationAndTariff";
import imgIconProgress1 from '../img/icon-progress1.svg';
import imgIconProgressGrey from '../img/icon-progress-grey.svg';
import imgIconProgressTick from '../img/icon-progress-tick.svg';

import "../css/style.css";

const Step10_Tickets_YouAreFamily = () => {
    const [posId, setPosId] = useState(null);

    const [event, setEvent] = useState({});

    const [ticketTypes, setTicketTypes] = useState([]);
    const [unlockedTicketTypes, setUnlockedTicketTypes] = useState([]);
    const [isTicketTypesUnlocked, setIsTicketTypesUnlocked] = useState(false);
    const [notAllowedPromotionCodes, setNotAllowedPromotionCodes] = useState([]);

    const [orderId, setOrderId] = useState(0);
    const [order, setOrder] = useState({});

    const [eventIdSammlung, setEventIdSammlung] = useState(0);

    const [promotioncode, setPromotioncode] = useState("");
    const [promotioncodeAdded, setPromotioncodeAdded] = useState("");
    const [promotionError, setPromotionError] = useState("");
    const [isPromotioncodeApplied, setIsPromotioncodeApplied] = useState("");

    const [isValid, setIsValid] = useState(false);
    const [loading, setLoading] = useState(true);

    let { language } = useParams();

    let languageId = 0;

    // changing languageId according to the url
    switch (language) {
        case ("de" || "DE"):
            languageId = 1;
            break;
        case ("fr" || "FR"):
            languageId = 2;
            break;
        case ("en" || "EN"):
            languageId = 3;
            break;
        case ("it" || "IT"):
            languageId = 4;
            break;
        default:
            languageId = 1;
            language = "de";
            break;
    }

    let navigate = useNavigate();
    let baseUrl = process.env.REACT_APP_BASEURL_API;
    api.defaults.baseURL = baseUrl;

    const [resources, setResources] = useState({});

    useEffect(() => {

        setLoading(true);
        const loadToken = async () => {
            try {
                const res = await axios.get("form/token");
                axios.defaults.headers.common["Authorization"] = "Bearer " + res.data;
                api.defaults.headers.common['Authorization'] = "Bearer " + res.data;
                await sessionStorage.setItem("token", res.data);
                requestFormSettings();
            } catch (error) {
                console.error(error);
            }
        };

        let currentOrderId = sessionStorage.getItem("OrderId");

        if (currentOrderId > 0) {
            setOrderId(currentOrderId);
        }

        const requestFormSettings = async () => {
            try {
                const res = await axios.get(`form/formsettings`);

                if (currentOrderId > 0) {
                    loadOrder(currentOrderId, true)
                } else {
                    startOrder(res.data.posId);
                }

                setNotAllowedPromotionCodes(res.data.notAllowedPromotionCodes);
                setPosId(res.data.posId)
                setEventIdSammlung(res.data.eventIdSammlung);
            } catch (error) {
                console.error(error);
            }
        };


        loadToken();
        setLoading(false);
    }, []);


    useEffect(() => {

        setLoading(true);

        const requestResources = async () => {
            try {
                const res = await axios.get(`form/resources/${language}`);
                setResources(res.data?.translation);
            } catch (error) {
                console.error(error);
            }
        };
        requestResources();
        setLoading(false);
    }, [language]);


    const YOU_ARE_FAMILY_EVENT_IDS = [212192, 212193, 215088];
    const YOU_ARE_FAMILY_TICKET_TYPE_IDS = [895884, 895970, 895971, 895991];

    useEffect(() => {
        if (orderId > 0) {
            loadYouAreFamilyTicketTypes(orderId);
        }
    }, [orderId]);

    const startOrder = async (posId) => {

        const order = {
            affiliateShopId: null,
            currency: "CHF",
            tenantId: 1,
            pointOfSaleId: posId ?? 6585,
            abbreviation: "",
            paymentType: 1,
        };

        try {
            const res = await axios.post(`${baseUrl}/ShopBasket/Order`, order);

            await sessionStorage.setItem("OrderId", res.data.id);

            setOrderId(res.data.id);

            return res.data;
        }
        catch (error) {
            console.error(error);
        }
    };

    const loadOrder = async (orderId, removeTickets) => {
        try {
            // Order
            let updatedOrder = await getOrderByOrderId(orderId);

            if (updatedOrder != null && updatedOrder.tickets != null && removeTickets) {

                let ticketTypeIdsToRemove = updatedOrder.tickets
                    .map(ticket => ticket.id);

                // DELETE request to remove tickets
                updatedOrder = await axios.delete(`${baseUrl}/ShopBasket/Order/${orderId}/Tickets`, {
                    data: { TicketsToRemove: ticketTypeIdsToRemove }
                });

                updatedOrder.tickets = [];
            }

            setOrder(updatedOrder);

            //validate page if user can proceed
            let quantity = 0;

            if (updatedOrder != null && updatedOrder.tickets != null) {
                quantity = updatedOrder.tickets.length;
            }

            if (quantity > 0) {
                setIsValid(true);
            } else {
                setIsValid(false);
            }
        }
        catch (error) {
            console.error(error);
        }
    }

    const getOrderByOrderId = async (orderId) => {
        try {
            const res = await axios.get(`${baseUrl}/ShopBasket/Order/${orderId}`);
            return res.data;
        }
        catch (error) {
            console.error(error);
            if (error.response.status === 404 || error.response.status === 403) {
                const newOrder = await startOrder(posId);
                return newOrder;
            }
        }
    }

    const loadYouAreFamilyTicketTypes = async (orderId) => {
        try {
            setLoading(true);

            // Fetch ticket types from all events in parallel
            const allTicketTypesRaw = await Promise.all(
                YOU_ARE_FAMILY_EVENT_IDS.map(eventId => getTicketTypesByEventId(eventId))
            );

            // Flatten and filter to only the allowed ticket type IDs
            const filteredTicketTypes = allTicketTypesRaw
                .flat()
                .filter(tt => YOU_ARE_FAMILY_TICKET_TYPE_IDS.includes(tt.id));

            // Enrich with infos and availability
            const updatedTicketTypes = await Promise.all(
                filteredTicketTypes.map(async (ticketType) => {
                    const info = await getTicketTypeInfosByTicketTypeId(ticketType.id);
                    const ticketTypeInfo = info.find(i => i.languageId == languageId) ?? info[0];
                    const ticketTypeAvailability = await getTicketTypeNumberOfAvailableTickets(ticketType.id, orderId);

                    return {
                        ...ticketType,
                        info: ticketTypeInfo,
                        availability: ticketTypeAvailability,
                    };
                })
            );

            setTicketTypes(updatedTicketTypes);
            setLoading(false);

        } catch (error) {
            console.error(error);
            setLoading(false);
        }
    }

    const onTicketTypeChange = (e, ticketTypeId) => {
        setLoading(true);

        const ticketToAdd = {
            ticketTypeId: ticketTypeId,
            quantity: e.target.value,
        };

        handleTicketsFromBasket(ticketToAdd);
    };

    const handleTicketsFromBasket = async (ticketToAdd) => {

        if (order != null && order.tickets != null) {
            let ticketTypeIdsToRemove = order.tickets
                .filter(ticket => ticket.ticketTypeId === ticketToAdd.ticketTypeId)
                .map(ticket => ticket.id);

            // DELETE request to remove tickets
            await axios.delete(`${baseUrl}/ShopBasket/Order/${orderId}/Tickets`, {
                data: { TicketsToRemove: ticketTypeIdsToRemove }
            });
        }

        let addTicketTypes = [];
        addTicketTypes.push(ticketToAdd);

        addTicketTypes = addTicketTypes.map((att) => {
            if (unlockedTicketTypes.includes(att.ticketTypeId)) {
                att.promotionCode = promotioncodeAdded;
            }
            return att;
        })

        //google tag manager add or remove tickets to cart
        let ticketType = ticketTypes.find(tt => tt.id === ticketToAdd.ticketTypeId);
        if (ticketType && ticketToAdd) {

            let ticketsWithSameTicketTypeId = [];

            if (order.tickets) {
                ticketsWithSameTicketTypeId = order.tickets.filter(t => t.ticketTypeId === ticketToAdd.ticketTypeId)
            }

            if (ticketsWithSameTicketTypeId.length < ticketToAdd.quantity) {
                const quantity = ticketToAdd.quantity - ticketsWithSameTicketTypeId.length;

                // gtm - add_to_cart
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event': 'add_to_cart',
                    'items': [
                        {
                            'item_id': ticketType.id,
                            'item_name': event.info?.name,
                            'item_variant': ticketType.info?.name,
                            'price': ticketType.price,
                            'quantity': quantity
                        }
                    ]
                });
            } else {
                const quantity = ticketsWithSameTicketTypeId.length - ticketToAdd.quantity;

                // gtm - remove_from_cart
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event': 'remove_from_cart',
                    'items': [
                        {
                            'item_id': ticketType.id,
                            'item_name': event.info?.name,
                            'item_variant': ticketType.info?.name,
                            'price': ticketType.price,
                            'quantity': quantity
                        }
                    ]
                });
            }
        }

        if (ticketToAdd.quantity > 0) {
            await axios
                .post(`${baseUrl}/ShopBasket/Order/${orderId}/Tickets`, {
                    ticketsToAdd: addTicketTypes,
                })
                .then(() => {
                    //// gtm - addToCart
                    //window.dataLayer = window.dataLayer || [];
                    //window.dataLayer.push({
                    //    'event': 'addToCart'
                    //});
                })
                .catch((error) => {
                    console.error(error.response.data);
                });
        }

        loadOrder(orderId, false);
    };

    const applyPromotionCodeToOrder = async (orderId, code) => {

        if (notAllowedPromotionCodes.includes(code.toLowerCase())) {
            setPromotionError(resources?.PromoCodeNotAllowed);
            return;
        }

        try {
            const response = await axios.put(`${baseUrl}/ShopBasket/Order/${orderId}/PromotionCode/${code}`);
            setIsPromotioncodeApplied(true);
            return response.data;
        } catch (error) {
            console.error(error.response.data);
            setPromotionError(error.response.data);
            setIsPromotioncodeApplied(false);
        }
    }

    const deletePromotionCodeFromOrder = async (orderId, code) => {
        try {
            const response = await axios.delete(`${baseUrl}/ShopBasket/Order/${orderId}/PromotionCode/${code}`);
            setPromotioncode("");
            setPromotioncodeAdded("");
            setIsPromotioncodeApplied(false);
            return response.data;
        } catch (error) {
            console.error(error.response.data);
            setPromotionError(resources.detailPage?.errorMessage);
        }
    }

    const getTicketTypeAvailability = async (ticketTypeId, orderId, promotionCode) => {
        try {
            const response = await axios.get(`${baseUrl}/TicketType/${ticketTypeId}/Availability?orderId=${orderId}&promotionCode=${promotionCode}`);
            return response.data;
        } catch (error) {
            console.error(error.response.data);
            setPromotionError(resources.detailPage?.errorMessage);
        }
    }

    const addPromotionToOrder = async () => {
        setPromotionError("");
        setLoading(true);

        const updatedUnlockedTicketTypes = await applyPromotionCodeToOrder(orderId, promotioncode);
        let updatedTicketTypes = [];

        updatedTicketTypes = await Promise.all(ticketTypes.map(async (ticketType) => {
            if (updatedUnlockedTicketTypes?.unlockedTicketTypes?.includes(ticketType.id)) {
                const unlockedTicketTypeAvailability = await getTicketTypeAvailability(ticketType.id, orderId, promotioncode);
                ticketType.availability = unlockedTicketTypeAvailability;
            }
            return ticketType;
        }))

        await sessionStorage.setItem("addedPromotion", promotioncode);
        setPromotioncodeAdded(promotioncode);

        setTicketTypes(updatedTicketTypes)
        setUnlockedTicketTypes(updatedUnlockedTicketTypes?.unlockedTicketTypes ?? []);
        setIsTicketTypesUnlocked(true);
        setLoading(false);
    }

    const removePromotionFromOrder = async () => {
        setPromotionError("");
        setLoading(true);

        await deletePromotionCodeFromOrder(orderId, promotioncode);
        await loadYouAreFamilyTicketTypes(orderId);

        setUnlockedTicketTypes([]);
        setIsTicketTypesUnlocked(false);
        setLoading(false);
    }

    const navigateToShipping = async () => {

        // gtm - begin_checkout
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'begin_checkout'
        });

        navigate(`/${language}/shipping`);
    }

    const mapTicketTypes = () => {
        let ticketTypesSorted = [];

        if (ticketTypes && ticketTypes.length > 0) {
            ticketTypesSorted = [...ticketTypes].sort((a, b) => a.sortOrder - b.sortOrder);
        }

        return (
            <div style={{ position: 'relative', opacity: loading ? 0.5 : 1, pointerEvents: loading ? 'none' : 'auto' }}>
                {ticketTypes &&
                    ticketTypes.length > 0 &&
                    ticketTypesSorted.map((tt, index) =>
                        (tt.availability?.availableTickets + (order.tickets?.filter((t) => t.ticketTypeId === tt.id)?.length ?? 0)) >= 0 ? (
                            <div
                                key={index}
                                className="row pt-2 pb-2 padding-left-25 padding-right-25"
                                style={{ backgroundColor: index % 2 === 0 ? 'transparent' : '#EFF2F3' }}
                            >
                                <div className="col-6 col-md-7 text-16-18 black-color text-start d-flex align-items-center padding-0">
                                    <label>{tt.info?.name}</label>
                                </div>
                                <div className="col-1 col-md-2 text-16-18 black-color d-flex justify-content-end align-items-center">
                                    <label>{tt.currency}</label>
                                </div>
                                <div className="col-2 col-md-2 text-16-18 black-color d-flex justify-content-start align-items-center">
                                    <label className="price-label text-end">{tt.price.toFixed(2)}</label>
                                </div>
                                <div className="col-3 col-md-1 text-16-18 black-color d-flex justify-content-start align-items-center padding-0">
                                    <select
                                        className="form-select"
                                        value={order && order.tickets ? order.tickets.filter((t) => t.ticketTypeId === tt.id).length : 0}
                                        onChange={(e) => onTicketTypeChange(e, tt.id)}
                                        disabled={loading}
                                    >
                                        {Array.from(
                                            Array(
                                                tt.availability?.availableTickets +
                                                1 +
                                                (order.tickets ? order.tickets.filter((t) => t.ticketTypeId === tt.id).length : 0)
                                            ),
                                            (e, i) => (
                                                <option key={i} value={i}>
                                                    {i}
                                                </option>
                                            )
                                        )}
                                    </select>
                                </div>
                            </div>
                        ) : null
                    )}
                {loading && (
                    <div
                        style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            backgroundColor: 'rgba(255, 255, 255, 0.7)',
                            zIndex: 10,
                        }}
                    >
                        <Loading bgColor="transparent" color="#d3d3d3" position="relative" />
                    </div>
                )}
            </div>
        );
    };

    const schemaData = {
        "@context": "https://schema.org",
        "@type": "Event",
        "name": "Summerfriends",
        "alternateName": [
            { "@language": "en", "@value": "Summerfriends" },
            { "@language": "fr", "@value": "Summerfriends" }
        ],
        "description": "Buchen Sie hier Ihre Tickets für die Sammlung des Kunsthaus Zürich. Das Kunsthaus Zürich verfügt mit rund 4000 Gemälden und Skulpturen und 95‘000 grafischen Werken, über eine der bedeutendsten Kunstsammlungen der Schweiz.",
        "alternateDescription": [
            { "@language": "en", "@value": "Book your tickets for the Kunsthaus Zürich collection here. With around 4000 paintings and sculptures and 95,000 graphic works, the Kunsthaus Zürich has one of the most important art collections in Switzerland." },
            { "@language": "fr", "@value": "Réservez ici vos billets pour la collection du Kunsthaus Zürich. Avec près de 4000 peintures et sculptures et 95'000 œuvres graphiques, le Kunsthaus Zürich dispose de l'une des plus importantes collections d'art de Suisse." }
        ],
        "image": "https://blog.ticketino.com/hubfs/Bilder/Kunsthaus%20Z%C3%BCrich/Ticket-Sammlung.jpg",
        "startDate": "2025-01-01",
        "endDate": "2025-12-31",
        "eventStatus": "https://schema.org/EventScheduled",
        "location": {
            "@type": "Museum",
            "name": "Kunsthaus Zürich",
            "address": {
                "@type": "PostalAddress",
                "streetAddress": "Heimpl. 1/5",
                "addressLocality": "Zürich",
                "postalCode": "8001",
                "addressRegion": "ZH",
                "addressCountry": "CH"
            }
        },
        "offers": [
            {
                "@type": "Offer",
                "priceCurrency": "CHF",
                "price": "24",
                "availability": "https://schema.org/InStock",
                "name": "Erwachsene",
                "alternateName": [
                    { "@language": "en", "@value": "Adult" },
                    { "@language": "fr", "@value": "Adultes" }
                ],
                "url": "https://tickets.kunsthaus.ch/de/summerfriends",
                "AlternateUrl": [
                    { "@language": "en", "@value": "https://tickets.kunsthaus.ch/en/summerfriends" },
                    { "@language": "fr", "@value": "https://tickets.kunsthaus.ch/fr/summerfriends" }
                ]
            },
            {
                "@type": "Offer",
                "priceCurrency": "CHF",
                "price": "17",
                "availability": "https://schema.org/InStock",
                "name": "Reduzierter Tarif",
                "alternateName": [
                    { "@language": "en", "@value": "Reduced admission" },
                    { "@language": "fr", "@value": "Tarif réduit" }
                ],
                "url": "https://tickets.kunsthaus.ch/de/summerfriends",
                "AlternateUrl": [
                    { "@language": "en", "@value": "https://tickets.kunsthaus.ch/en/summerfriends" },
                    { "@language": "fr", "@value": "https://tickets.kunsthaus.ch/fr/summerfriends" }
                ]
            },
            {
                "@type": "Offer",
                "priceCurrency": "CHF",
                "price": "0",
                "availability": "https://schema.org/InStock",
                "name": "Kostenloser Eintritt",
                "alternateName": [
                    { "@language": "en", "@value": "Free admission" },
                    { "@language": "fr", "@value": "Entrée gratuite" }
                ],
                "url": "https://tickets.kunsthaus.ch/de/summerfriends",
                "AlternateUrl": [
                    { "@language": "en", "@value": "https://tickets.kunsthaus.ch/en/summerfriends" },
                    { "@language": "fr", "@value": "https://tickets.kunsthaus.ch/fr/summerfriends" }
                ]
            }
        ],
        "organizer": {
            "@type": "Museum",
            "name": "Kunsthaus Zürich",
            "url": "https://kunsthaus.ch/"
        }
    };

    const location = useLocation();
    const currentUrl = `https://tickets.kunsthaus.ch${location.pathname}`;

    return (
        <>
            <Helmet>
                <title>{resources?.HeadSummerFriendsTitle}</title>

                <link rel="canonical" href="https://tickets.kunsthaus.ch/de/summerfriends" />
                <link rel="alternate" hreflang="de" href="https://tickets.kunsthaus.ch/de/summerfriends" />
                <link rel="alternate" hreflang="en" href="https://tickets.kunsthaus.ch/en/summerfriends" />
                <link rel="alternate" hreflang="fr" href="https://tickets.kunsthaus.ch/fr/summerfriends" />
                <link rel="alternate" hreflang="x-default" href="https://tickets.kunsthaus.ch/de/summerfriends" />

                <meta name="description" content={resources?.HeadCollectionDescription || "Buchen Sie hier Ihre Tickets für die Sammlung des Kunsthaus Zürich. Das Kunsthaus Zürich verfügt mit rund 4000 Gemälden und Skulpturen und 95‘000 grafischen Werken, über eine der bedeutendsten Kunstsammlungen der Schweiz."} />
                <meta name="keywords" content={resources?.HeadCollectionKeywords || "Kunsthaus Zürich Tickets, Eintrittskarten Kunstmuseum Schweiz, Tickets für Kunstsammlungen, Kunsthaus Zürich Eintritt kaufen, Eintrittskarten für Kunstausstellungen Zürich, Schweizer Kunstmuseum Tickets, Kunstmuseum Eintritt, Kunsthaus Zürich Eintrittskarten, Tickets für Kunstsammlungsausstellungen"} />

                {/*  Open Graph Meta Tags */}
                <meta property="og:title" content={resources?.HeadSummerFriendsTitle || "Tickets online kaufen – Summerfriends – Kunsthaus Zürich"} />
                <meta property="og:description" content={resources?.HeadCollectionOgDescription || "Das Kunsthaus Zürich, das grösste Kunstmuseum der Schweiz, bietet eine einzigartige Sammlung von der Kunst des Mittelalters bis zur Gegenwart, mit wechselnden Ausstellungen."} />
                <meta property="og:type" content="website" />
                <meta property="og:url" content={currentUrl} />
                <meta property="og:image" content="https://localhost:44424/static/media/summercampaign-summerfriends_de.61ecd9203f8db26c8b0f.jpg" />

                <script type="application/ld+json">
                    {JSON.stringify(schemaData)}
                </script>
            </Helmet>

            <div className="d-flex flex-column min-vh-100">
                <Navbar numberOfTickets={order?.tickets?.length ?? 0} isShoppingCartVisible={true} pagePath="summerfriends" />
                <main className="flex-fill">
                    {resources && (
                        <div className="container page-wrapper">

                            <div className="progress-container">

                                <div className="progress-step completed">
                                    <div>
                                        <div className="image">
                                            <img src={imgIconProgress1} alt=" Step 1" />
                                        </div>
                                        <div className="step-number text-wrap visible-desktop">{resources?.TicketSelection}</div>
                                    </div>
                                    <div className="line"></div>
                                </div>

                                <div className="progress-step">
                                    <div>
                                        <div className="image">
                                            <img src={imgIconProgressGrey} alt="Step 2" />
                                        </div>
                                        <div className="step-number text-wrap visible-desktop">{resources?.SummaryAndContact}</div>
                                    </div>
                                    <div className="line"></div>
                                </div>

                                <div className="progress-step">
                                    <div>
                                        <div className="image">
                                            <img src={imgIconProgressGrey} alt="Step 3" />
                                        </div>
                                        <div className="step-number text-wrap visible-desktop">{resources?.PaymentAndDelivery}</div>
                                    </div>
                                </div>
                            </div>
                            <div className="row mt-5 sticky-wrapper">
                                <div className="col-md-8 padding-0">
                                    <p className="text-50-55 black-color font-500">YOU ARE FAMILY</p>
                                    <p className="text-30-36-bold black-color pb-0">13.7.-15.8.2026</p>
                                </div>
                            </div>

                            <br />

                            {mapTicketTypes()}


                            <div className="row mt-5">
                                <div className="col-md-7 col-6 text-18-21 black-color d-flex justify-content-start align-items-center padding-0">{resources.Total}:</div>
                                <div className="col-1 col-md-2 text-18-21 black-color d-flex justify-content-end align-items-center">
                                    <label className="font-600 padding-right-10">
                                        CHF
                                    </label>
                                </div>
                                <div className="col-2 col-md-1 text-18-21 black-color d-flex justify-content-start align-items-center">
                                    <label className="font-600 price-label text-end padding-right-10"> {order && order.total && order.total !== null ? (
                                        <span>{(order.total).toFixed(2)}</span>
                                    ) : (
                                        <span>0.00</span>
                                    )}
                                    </label>
                                </div>
                            </div>

                            {(order && (order.tickets === undefined || order.tickets.length === 0)) && (
                                <div className="row mt-2">
                                    <div className="col-md-7 col-6 text-18-21 red d-flex justify-content-start align-items-center padding-0">{resources?.TicketChoose}</div>
                                </div>
                            )}

                            <div className="row mt-5 mb-5">
                                <div className="col-6 d-flex justify-content-start align-items-center padding-0">
                                    <button className="btn transperant-grey-button" onClick={() => navigate(-1)}>
                                        {resources?._Back}
                                    </button>
                                </div>
                                <div className="col-6 d-flex justify-content-end align-items-center padding-0">
                                    <button
                                        className="btn grey-button "
                                        disabled={!isValid}
                                        onClick={() => navigateToShipping()}
                                    >
                                        {resources?.BookNow}
                                    </button>
                                </div>
                            </div>
                            <InformationAndTariff />

                        </div>
                    )}
                </main>
                <Footer />
            </div>
        </>
    );
};

export default Step10_Tickets_YouAreFamily;